import React from "react";

const ResidentsTableEmptyMessage = () => {
    return (
        <div>
            No residents have been added yet. Select <b>New Resident</b> to create the resident.
        </div>
    );
};

export default ResidentsTableEmptyMessage;